class BestDiscountCalculator {
    constructor() {
      this.discountCodes = [];
      this.productPrice = 0;
      this.bestDiscount = null;
      this.debugMode = true;
    }
  
    log(message, data = null) {
      if (this.debugMode) {
        console.log(`[BestDiscount] ${message}`, data || '');
      }
    }
  
    async init() {
      this.getProductPrice();
      await this.fetchDiscountCodes();
      this.calculateBestDiscount();
      this.renderBestDiscount();
    }
  
    getProductPrice() {
      const productData = window.product || {};
      const selectedVariant = productData.selected_or_first_available_variant || productData.variants?.[0];
  
      if (selectedVariant && selectedVariant.price) {
        this.productPrice = selectedVariant.price / 100;
      } else {
        const priceElement = document.querySelector('.price__regular .price-item--regular');
        if (priceElement) {
          const priceText = priceElement.textContent.replace(/[^\d.]/g, '');
          this.productPrice = parseFloat(priceText) || 0;
        } else {
          this.productPrice = 0;
        }
      }
  
      this.log('Product price:', this.productPrice);
    }
  
    async fetchDiscountCodes() {
      try {
        if (window.discountCodes && Array.isArray(window.discountCodes)) {
          this.discountCodes = window.discountCodes;
          this.log('Fetched discount codes:', this.discountCodes);
          return;
        }
        this.log('No discount codes found');
        this.discountCodes = [];
      } catch (error) {
        this.log('Error fetching discount codes:', error);
        this.discountCodes = [];
      }
    }
  
    calculateBestDiscount() {
      if (!this.discountCodes.length) {
        this.log('No discount codes available');
        return;
      }
    
      if (!window.product) {
        this.log('No product data available');
        return;
      }
    
      const productId = String(window.product.id);
      const productCollections = window.product.collections || [];
      const productCollectionIds = productCollections.map(col => String(col.id));
    
      const linked_coupons = [];
    
      this.discountCodes.forEach(discount => {
        const linkedProducts = discount.linked_products || [];
        const associatedCollections = discount.associated_collections || [];
    
        const linkedProductIds = linkedProducts.map(p =>
          typeof p === 'object' && p !== null ? String(p.id) : String(p)
        );
    
        const associatedCollectionIds = associatedCollections.map(c =>
          typeof c === 'object' && c !== null ? String(c.id) : String(c)
        );
    
        const isLinkedToProduct = linkedProductIds.includes(productId);
        const isLinkedToCollection = associatedCollectionIds.some(id =>
          productCollectionIds.includes(id)
        );
    
        if (isLinkedToProduct || isLinkedToCollection) {
          this.log(`Matched discount "${discount.code}" as linked`);
          linked_coupons.push(discount);
        }
      });
    
      if (linked_coupons.length > 0) {
        this.bestDiscount = this.findBestDiscount(linked_coupons);
        this.log('Best linked discount selected:', this.bestDiscount);
        return;
      }
    
      const general_coupons = this.discountCodes.filter(discount => {
        const linkedProducts = discount.linked_products || [];
        const associatedCollections = discount.associated_collections || [];
        return linkedProducts.length === 0 && associatedCollections.length === 0;
      });
    
      if (general_coupons.length > 0) {
        this.bestDiscount = this.findBestDiscount(general_coupons);
        this.log('Best general discount selected:', this.bestDiscount);
      } else {
        this.bestDiscount = null;
        this.log('No valid discounts found');
      }
    }
    
  
    findBestDiscount(discounts) {
      let bestDiscount = null;
      let maxSavings = 0;
  
      discounts.forEach(discount => {
        const minValue = discount.min_value || 0;
        const maxValue = discount.max_value || Infinity;
  
        if (this.productPrice < minValue || this.productPrice > maxValue) {
          return;
        }
  
        let calculatedAmount = 0;
  
        if (discount.discount_type === 'percentage') {
          calculatedAmount = this.productPrice * (discount.discount_amount / 100);
        } else if (discount.discount_type === 'fixed') {
          calculatedAmount = discount.discount_amount;
        }
  
        if (calculatedAmount > maxSavings) {
          maxSavings = calculatedAmount;
          bestDiscount = {
            code: discount.code,
            type: discount.discount_type,
            value: discount.discount_amount,
            amount: calculatedAmount,
            label: discount.discount_type === 'percentage'
              ? `${discount.discount_amount}% OFF`
              : `₹${discount.discount_amount} OFF`
          };
        }
      });
  
      return bestDiscount;
    }
  
    renderBestDiscount() {
      const container = document.querySelector('.best-discount-container');
      if (!container) return;
  
      if (this.bestDiscount) {
        const savingsAmount = Math.round(this.bestDiscount.amount);
        const originalPrice = Math.round(this.productPrice);
        const finalPrice = originalPrice - savingsAmount;
  
        container.innerHTML = `
          <div class="best-discount-coupon" style="
            margin-bottom: 8px; 
            padding: 12px 16px; 
            background: #f0f8f0; 
            border: none;
            display: flex; 
            align-items: center; 
            justify-content: space-between;
            font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
          ">
            <div style="flex: 1;">
              <div style="
                color: #2e7d32; 
                font-weight: 600; 
                font-size: 16px; 
                margin-bottom: 2px;
              ">
                Get your products for ₹${finalPrice.toLocaleString('en-IN')} with coupon
              </div>
              <div style="
                color: #666; 
                font-size: 14px;
              ">
                You save ₹${savingsAmount.toLocaleString('en-IN')} (${this.bestDiscount.label})
              </div>
            </div>
            <div 
              class="coupon-code-button" 
              onclick="window.bestDiscountCalculator.copyToClipboard('${this.bestDiscount.code}')"
              style="
                background: #fff; 
                border: 1px dashed #2e7d32; 
                border-radius: 6px; 
                padding: 8px 12px; 
                font-weight: bold; 
                color: #2e7d32;
                font-size: 14px;
                letter-spacing: 0.5px;
                cursor: pointer;
                transition: all 0.2s ease;
                user-select: none;
              "
              onmouseover="this.style.backgroundColor='#e8f5e8'; this.style.transform='scale(1.02)'"
              onmouseout="this.style.backgroundColor='#fff'; this.style.transform='scale(1)'"
              title="Click to copy coupon code"
            >
              ${this.bestDiscount.code}
            </div>
          </div>
        `;
  
        container.style.display = 'block';
      } else {
        container.style.display = 'none';
      }
    }
  
    async copyToClipboard(code) {
      try {
        if (navigator.clipboard && window.isSecureContext) {
          await navigator.clipboard.writeText(code);
          this.showToast(`Coupon code "${code}" copied to clipboard!`);
        } else {
          const textArea = document.createElement('textarea');
          textArea.value = code;
          textArea.style.position = 'fixed';
          textArea.style.left = '-999999px';
          textArea.style.top = '-999999px';
          document.body.appendChild(textArea);
          textArea.focus();
          textArea.select();
          const successful = document.execCommand('copy');
          document.body.removeChild(textArea);
          if (successful) {
            this.showToast(`Coupon code "${code}" copied to clipboard!`);
          } else {
            this.log('Failed to copy coupon code (fallback)');
          }
        }
      } catch (err) {
        this.log('Error copying to clipboard:', err);
      }
    }
  
    showToast(message, type = 'success') {
      const toastManager = document.querySelector('toast-message-manager');
      if (toastManager && typeof toastManager.pushMessage === 'function') {
        toastManager.pushMessage(message, type);
      } else {
        this.log('Toast message:', message);
      }
    }
  }
  
  // Initialize on DOM load
  document.addEventListener('DOMContentLoaded', () => {
    window.bestDiscountCalculator = new BestDiscountCalculator();
    window.bestDiscountCalculator.init();
  });
  
  // Fallback in case DOM already loaded
  if (document.readyState !== 'loading') {
    window.bestDiscountCalculator = new BestDiscountCalculator();
    window.bestDiscountCalculator.init();
  }
  